import {
  ChevronDown as ArrowDownIcon,
  ChevronUp as ArrowUpIcon,
} from "lucide-react";

export default function Icon({ open }: { open: boolean }) {
  if (open) return <ArrowUpIcon strokeWidth={1} className="size-4.5" />;
  return <ArrowDownIcon strokeWidth={1} className="size-4.5" />;
}
